import policeContactMessage from './policeContactMessage';

export default {
	policeContactMessage
};
